/** Moldura das telas públicas — entrar, esqueci a senha, criar senha.
 *
 * À esquerda, a Oficina Fraterna se apresenta: quem chega pela primeira vez
 * (um irmão recém-iniciado, a diretoria de outra loja) entende o que é o
 * sistema antes de entrar. À direita, o formulário. No celular a apresentação
 * vira só a marca, em cima — ninguém rola uma vitrine para achar o login.
 */

import type { ReactNode } from 'react';

import { Icone, type NomeIcone } from './Icone';
import { LogoOficinaFraterna } from './LogoOficinaFraterna';

export const NOME_DO_SISTEMA = 'Oficina Fraterna';

const RECURSOS: { icone: NomeIcone; titulo: string; texto: string }[] = [
  {
    icone: 'pessoas',
    titulo: 'Quadro de obreiros',
    texto: 'Cadastro completo, graduações, família e frequência de cada irmão.',
  },
  {
    icone: 'carteira',
    titulo: 'Tesouraria',
    texto: 'Mensalidades, acordos e a situação de cada irmão, sempre em dia.',
  },
  {
    icone: 'fluxo',
    titulo: 'Financeiro',
    texto: 'Receitas, despesas, orçamento e extrato bancário conciliado.',
  },
  {
    icone: 'pena',
    titulo: 'Sessões e Chancelaria',
    texto: 'Livro de presença, tronco, atas e o calendário da Loja.',
  },
  {
    icone: 'estrela',
    titulo: 'Eventos',
    texto: 'Cotas, convites, despesas e a apuração de cada evento.',
  },
  {
    icone: 'escudo',
    titulo: 'Cada um no seu cargo',
    texto: 'Acesso por função e histórico de tudo o que foi alterado.',
  },
];

export function TelaDeAcesso({ children }: { children: ReactNode }) {
  return (
    <div className="acesso">
      <aside className="acesso-vitrine">
        <LogoOficinaFraterna tom="negativa" altura={52} className="acesso-logo" />

        <div className="acesso-chamada">
          <h1>
            A gestão da Loja,
            <br />
            <em>em um só lugar.</em>
          </h1>
          <p>
            Secretaria, Tesouraria e Chancelaria trabalhando juntas — e cada irmão acompanhando o
            que é seu, de qualquer aparelho.
          </p>
        </div>

        <ul className="acesso-recursos">
          {RECURSOS.map((r) => (
            <li key={r.titulo}>
              <span className="acesso-recurso-icone">
                <Icone nome={r.icone} tamanho={18} />
              </span>
              <div>
                <strong>{r.titulo}</strong>
                <span>{r.texto}</span>
              </div>
            </li>
          ))}
        </ul>

        <div className="acesso-rodape">
          © {new Date().getFullYear()} {NOME_DO_SISTEMA} · Feito para Lojas Maçônicas
        </div>
      </aside>

      <main className="acesso-painel">
        <div className="acesso-painel-interno">{children}</div>
      </main>
    </div>
  );
}
